import { getUserEmail } from '../../../utils/get-user-email';

export const SIGNER_OPTION_COLORS = [
	'#A8DADC', // Pale turquoise
	'#F4A261', // Soft orange
	'#B5E48C', // Light lime green
	'#FFD6A5', // Peach
	'#9ADCFF', // Light blue
	'#D0F4DE', // Mint
	'#CDB4DB', // Pale lavender
	'#FFADAD', // Light coral
	'#CAF0F8', // Sky blue
	'#E4C1F9', // Lilac
	'#FFF5BA', // Soft yellow
	'#D8E2DC', // Light warm grey
	'#B9FBC0', // Pale seafoam
	'#FBC4AB', // Apricot
	'#C6DEF1', // Soft steel blue
] as const;

export type DocumentSignerOption = {
	value: string;
	label: string;
	color: (typeof SIGNER_OPTION_COLORS)[number];
};

export type SignerEntry = DocumentSignerOption & {
	order: number;
	expiration: string; // ISO 8601 date
	role: 'signer';
	signatureType?: string;
};
